/**
 * migracion_bid_frontend/src/components/404/NotFound.js
 */

import React from "react";

function NotFound() {
  return (
    <div>
      <h2>Not found</h2>
    </div>
  );
}

export default NotFound;
